import { getPriceWithCurrencyWithoutRounding } from 'src/utils';
import styles from './ModelPricingMobileRow.module.scss';
import { TextDivider } from 'src/v2/commonComponents/TextDivider';

interface ModelPricingMobileRowProps {
  modelName: string;
  inputPrice?: number;
  outputPrice?: number;
  price?: number;
  currency: string;
  modelDescription?: string;
  defaultModels?: React.ReactNode;
}

export const ModelPricingMobileRow = ({
  modelName,
  inputPrice,
  outputPrice,
  price,
  currency,
  modelDescription,
  defaultModels,
}: ModelPricingMobileRowProps) => {
  return (
    <div className={styles.item}>
      <div className={styles.header}>
        <span className={styles.headerCaption}>Model</span>
        <span className={styles.label}>{modelName}</span>
        {modelDescription && (
          <span className={styles.description}>{modelDescription}</span>
        )}
        {defaultModels && <div>{defaultModels}</div>}
      </div>

      <TextDivider type="dashed" />

      {inputPrice && (
        <p className={styles.row}>
          <span>
            Input price /{' '}
            <span className={styles.itemCaption}>per million tokens</span>
          </span>
          <span className={styles.label}>
            {getPriceWithCurrencyWithoutRounding(inputPrice, currency)}
          </span>
        </p>
      )}

      {outputPrice && (
        <p className={styles.row}>
          <span>
            Output price /{' '}
            <span className={styles.itemCaption}>per million tokens</span>
          </span>
          <span className={styles.label}>
            {getPriceWithCurrencyWithoutRounding(outputPrice, currency)}
          </span>
        </p>
      )}

      {/* {price && (
        <p className={styles.row}>
          <span>
            Price / <span className={styles.itemCaption}>task</span>
          </span>
          <span className={styles.label}>
            {getPriceWithCurrencyWithoutRounding(price, currency)}
          </span>
        </p>
      )} */}
    </div>
  );
};
